import {
	default as React,
	type ReactNode,
	createContext,
	useContext,
} from "react";
import { useComplexState } from "use-complex-state";
import { LogsReducer } from "../reducers/LogsReducer";

const LogsContext = createContext({
	state: LogsReducer.getInitialState(),
	actions: LogsReducer.actions,
});

export const useLogsContext = () => useContext(LogsContext);

export const LogsProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: LogsReducer.getInitialState(),
		reducers: LogsReducer.caseReducers,
	});

	return (
		<LogsContext.Provider value={{ state, actions }}>
			{children}
		</LogsContext.Provider>
	);
};
